import { ConfigItem } from '../base-definitions'
import { TooltipDefinition } from '../form-definitions'
import { ButtonAlign } from '../form-definitions/button-align'
import { BaseActionDefinition } from './base-action-definition'

export enum FormVisibility {
  Readonly = 10,
  Edit = 20,
  Both = 30,
}

export enum CustomActionPosition {
  InsideView,
  OutsideView,
}

export enum CustomActionButtonAspect {
  Primary,
  Secondary,
  Alternative,
  IconOnly,
}

export enum CustomActionIconAlign {
  Left,
  Right,
}

export enum CustomActionPositionToDivider {
  Above,
  Below,
}

export class CustomActionDefinition extends BaseActionDefinition {
  public fullName: string
  public nextTo: string
  public prevTo: string
  public customUI: string
  public api: string
  public apiRequireClaim: string
  public isGrouped: boolean
  public actionId: string
  public position: CustomActionPosition
  public buttonAspect?: CustomActionButtonAspect
  public formVisibility: FormVisibility
  public config: ConfigItem[]
  public iconAlign: CustomActionIconAlign
  public buttonAlign: ButtonAlign
  public positionToDivider: CustomActionPositionToDivider
  public tooltip?: TooltipDefinition

  constructor(model: CustomActionDefinition) {
    super(model)
    this.fullName = model.fullName
    this.nextTo = model.nextTo
    this.prevTo = model.prevTo
    this.customUI = model.customUI
    this.api = model.api
    this.apiRequireClaim = model.apiRequireClaim
    this.actionId = model.actionId
    this.isGrouped = model.isGrouped
    this.position = model.position ?? CustomActionPosition.InsideView
    this.buttonAspect = model.buttonAspect ?? CustomActionButtonAspect.Primary
    this.config = model.config
    this.formVisibility = model.formVisibility
    this.iconAlign = model.iconAlign ?? CustomActionIconAlign.Left
    this.buttonAlign = model.buttonAlign ?? ButtonAlign.Right
    this.positionToDivider = model.positionToDivider ?? CustomActionPositionToDivider.Above
    this.tooltip = model?.tooltip
  }

  public getClassName(): string {
    if (!this.fullName || this.fullName == '') throw new Error('[CustomActionDefinition] fullName cannot be empty!')

    const cleanedString = this.fullName.replace(/\s/g, '')
    const splitted = cleanedString.split(',')

    if (splitted.length != 2) throw new Error('[CustomActionDefinition] fullName is malformed!')

    return splitted[1]
  }
}
